module.exports = __webpack_public_path__ + "img/1571873375.3819267c.jpg";